import {
  Slider as SliderCore,
  SliderItem,
  SliderDrag,
  SliderProgress,
  SliderBtn,
  SliderDots,
} from '@studiometa/ui';

/**
 * SliderPDP component
 */
export default class SliderPDP extends SliderCore {
  /**
   * Component Configuration
   */
  static config = {
    ...SliderCore.config,
    name: 'SliderPDP',
    components: {
      ...SliderCore.config.components,
      SliderItem,
      SliderBtn,
      SliderDrag,
      SliderDots,
      SliderProgress,
    },
  };
}
